// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"1802360d","878":"88882e4a"}[chunkId] + ".chunk.js";
};